var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createContext, useContext, useState } from 'react';
import { useWrapAsync, useAsyncEffect } from '@loop/comm-display-util-dom';
const AuthContext = createContext(null);
export const AuthContextProvider = AuthContext.Provider;
export const clearAuth = () => {
    localStorage.removeItem('auth_token');
    window.location.reload();
};
const getOperatorTokenInfo = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''));
    return JSON.parse(jsonPayload);
};
export const setupAuth = (config) => {
    const { error, wrapAsync } = useWrapAsync();
    const [state, setState] = useState({ clearAuth, authToken: null, operatorInfo: null });
    const { fetch: origFetch } = window;
    window.fetch = (...args) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield origFetch(...args);
        if (response.status === 401) {
            clearAuth();
            return {};
        }
        return response;
    });
    useAsyncEffect(wrapAsync(() => __awaiter(void 0, void 0, void 0, function* () {
        if (config) {
            try {
                const authToken = localStorage.getItem('auth_token');
                if (!authToken) {
                    throw new Error('auth token not found');
                }
                setState(Object.assign(Object.assign({}, state), { authToken, operatorInfo: getOperatorTokenInfo(authToken) }));
            }
            catch (e) {
                const urlParams = new URLSearchParams(window.location.search);
                let actionParam = (urlParams && urlParams.get('action')) || 'login';
                if (!['login', 'signup', 'logout'].indexOf(actionParam)) {
                    actionParam = 'login';
                }
                const callback = `${window.location.origin}/support-callback.html`;
                const loginUrl = `${config.supportCognitoBaseUrl}/${actionParam}?redirect_uri=${callback}&response_type=token&client_id=${config.supportClientId}&scope=email openid`;
                window.location.href = loginUrl;
            }
        }
    })), [config]);
    return {
        error,
        state,
    };
};
export const useAuthContext = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error('AuthContext not set');
    }
    return ctx;
};
//# sourceMappingURL=auth.js.map